// Mock data for OHMNAI - frontend only version

export const mockValues = [
  { id: 'environment', label: 'Environment', description: 'Clean air, water, and living systems' },
  { id: 'dignity', label: 'Dignity', description: 'Respect and fairness for all people' },
  { id: 'knowledge', label: 'Knowledge', description: 'Learning, understanding, and wisdom' },
  { id: 'future', label: 'Future', description: 'Long-term thinking and sustainability' },
  { id: 'health', label: 'Health', description: 'Physical and mental wellbeing' },
  { id: 'creativity', label: 'Creativity', description: 'Art, expression, and innovation' },
  { id: 'community', label: 'Community', description: 'Connection and belonging' },
  { id: 'stability', label: 'Stability', description: 'Safety and security' },
  { id: 'animals', label: 'Animals', description: 'Care for other living beings' },
  { id: 'other', label: 'Other', description: 'Something else that matters to you' }
];

export const mockActionSuggestions = [
  {
    id: 'action-1',
    title: 'Sign a petition for local water protection',
    description: 'Your local watershed needs support. A petition is circulating to prevent industrial runoff.',
    effort: '5 minutes',
    impact: 'Adds your voice to a formal request',
    reasoning: 'This aligns with your care for the environment and requires minimal time.'
  },
  {
    id: 'action-2',
    title: 'Read one article on climate science',
    description: 'A recent article explains climate tipping points in plain language.',
    effort: '10 minutes',
    impact: 'Deepens your understanding',
    reasoning: 'This matches your interest in knowledge and the environment, and fits your current capacity.'
  },
  {
    id: 'action-3',
    title: 'Donate $5 to a food bank',
    description: 'A local organization provides meals to families in need.',
    effort: '3 minutes',
    impact: 'Provides immediate support',
    reasoning: 'This aligns with your care for dignity and community, within your stated financial capacity.'
  }
];

// Mock user profile
export const mockUserProfile = {
  id: 'mock-user-1',
  selectedValues: [],
  personalValues: [],
  capacity: {
    time: 'none',
    money: 'none',
    attention: 'low'
  },
  goalText: '',
  boundaries: {
    avoidTopics: []
  },
  completedAt: null
};

// Mock Circle member data
export const mockCircleMember = {
  isMember: false,
  joinedAt: null,
  subscriptionStatus: 'inactive'
};

// Save profile to localStorage
export const saveProfile = (profile) => {
  localStorage.setItem('ohmnai_profile', JSON.stringify(profile));
};

// Load profile from localStorage
export const loadProfile = () => {
  const saved = localStorage.getItem('ohmnai_profile');
  return saved ? JSON.parse(saved) : null;
};

// Clear profile
export const clearProfile = () => {
  localStorage.removeItem('ohmnai_profile');
  localStorage.removeItem('ohmnai_user');
};

// Mock user for auth simulation
export const saveUser = (user) => {
  localStorage.setItem('ohmnai_user', JSON.stringify(user));
};

export const loadUser = () => {
  const saved = localStorage.getItem('ohmnai_user');
  return saved ? JSON.parse(saved) : null;
};
